import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, FilterIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { PartyFiltersBar } from '../../components/party/PartyFiltersBar';
import { PartyTable } from '../../components/party/PartyTable';
import { Party, PartyFilters } from '../../types/party.types';
import { partyService } from '../../services/party.service';
export function PartyListPage() {
  const navigate = useNavigate();
  const [parties, setParties] = useState<Party[]>([]);
  const [loading, setLoading] = useState(true);
  const [showFilters, setShowFilters] = useState(true);
  const [filters, setFilters] = useState<PartyFilters>({
    page: 1,
    limit: 20
  });
  // Mock permissions - in real app, get from auth context
  const userPermissions = {
    canCreateParty: true,
    canEditParty: true,
    canViewAllParties: true,
    canToggleStatus: true
  };
  useEffect(() => {
    loadParties();
  }, [filters]);
  const loadParties = async () => {
    setLoading(true);
    try {
      const response = await partyService.getParties(filters);
      setParties(response.data);
    } catch (error) {
      console.error('Failed to load parties:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleFiltersChange = (newFilters: PartyFilters) => {
    setFilters({
      ...newFilters,
      page: 1
    });
  };
  const handleClearFilters = () => {
    setFilters({
      page: 1,
      limit: 20
    });
  };
  return <div className="min-h-screen bg-gray-50 p-6" data-id="element-1249">
      <div className="max-w-7xl mx-auto space-y-6" data-id="element-1250">
        {/* Header */}
        <div className="flex items-center justify-between" data-id="element-1251">
          <div data-id="element-1252">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-1253">
              Party Management
            </h1>
            <p className="text-sm text-gray-600 mt-1" data-id="element-1254">
              Manage customers, vendors, and view employees
            </p>
          </div>
          <div className="flex gap-2" data-id="element-1255">
            <Button variant="secondary" onClick={() => setShowFilters(!showFilters)} data-id="element-1256">
              <FilterIcon className="w-4 h-4 mr-2" data-id="element-1257" />
              {showFilters ? 'Hide' : 'Show'} Filters
            </Button>
            {userPermissions.canCreateParty && <Button onClick={() => navigate('/parties/new')} data-id="element-1258">
                <PlusIcon className="w-4 h-4 mr-2" data-id="element-1259" />
                Add Party
              </Button>}
          </div>
        </div>

        {/* Filters */}
        {showFilters && <PartyFiltersBar filters={filters} onFiltersChange={handleFiltersChange} onClear={handleClearFilters} data-id="element-1260" />}

        {/* Table */}
        <PartyTable parties={parties} loading={loading} canEdit={userPermissions.canEditParty} data-id="element-1261" />
      </div>
    </div>;
}